var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.has_afip_ticket)?_c('b-dropdown-item',{on:{"click":_vm.makeAfipTicket}},[_c('i',{staticClass:"icon-tag"}),_vm._v(" Hacer Factura ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }